import styled from "styled-components";

export const Main = styled.main`
  height: 100vh;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing?.medium || "20px"};
  box-sizing: border-box;
`;
